import {users} from '@cl/shared';
import {getClientId} from 'common/src/modules/auth/auth.service';
import {ClientType} from 'common/src/modules/clients/clients.types';
import {UserClient} from 'common/src/modules/users/users.types';
import {
  AiZendeskBusinessImpact,
  AiZendeskSupportRequestType,
  ZendeskBusinessImpact,
  ZendeskSupportRequestType,
} from 'common/src/modules/zendesk/zendesk.enums';
import {ZendeskSupportForm} from 'common/src/modules/zendesk/zendesk.types';
import getMatchingEnumValue from 'common/src/utils/typescriptUtils/getMatchingEnumValue';
import {z} from 'zod';
import {launchSupportFormInputSchema} from '../launchSupportFormTool.schemas';

function convertToZendeskSupportForm(
  input: z.infer<typeof launchSupportFormInputSchema>,
): ZendeskSupportForm {
  const user = users.userSubject.data;
  const currentClientId = getClientId();
  const account = user?.relatedClients.find((client) => client.id === currentClientId);
  const agency = _getAgencyName(account, user?.relatedClients, currentClientId);
  const requestType =
    getMatchingEnumValue(
      AiZendeskSupportRequestType,
      ZendeskSupportRequestType,
      input.requestType,
    ) ?? ZendeskSupportRequestType.GeneralQuestion;
  const businessImpact =
    getMatchingEnumValue(AiZendeskBusinessImpact, ZendeskBusinessImpact, input.businessImpact) ??
    ZendeskBusinessImpact.Normal;

  return {
    name: [user?.firstName, user?.lastName].filter(Boolean).join(' '),
    email: user?.email ?? '',
    agency,
    account: account?.name ?? '',
    requestType,
    businessImpact,
    subject: input.subject,
    description: input.description,
    campaignId: input.campaignId ?? '',
    feedId: input.feedId ?? '',
    creativeTemplateId: input.creativeTemplateId ?? '',
    creativeId: input.creativeId ?? '',
  };
}

function _getAgencyName(
  account: UserClient | undefined,
  relatedClients: UserClient[] | undefined,
  clientId: number,
): string {
  if (account?.clientType === ClientType.Agency) return account.name;

  const agencyClient = relatedClients?.find(
    (client) =>
      client.clientType === ClientType.Agency &&
      (client.connectedAdvertisers?.some((advertiser) => advertiser.id === clientId) ?? false),
  );

  return agencyClient?.name ?? '';
}

export default convertToZendeskSupportForm;
